import defaultImage from "../assets/others/logo.png";

export const defaultChatBotSettings = {
    title: 'Botcircuits',
    subTitle: 'Ready to help',
    welcomeMessage: '',
    tips: [],
    inputPlaceHolder: 'Type a message...',
    logo: defaultImage,
    primaryColor: '#bae61a',
    headerBackgroundColor: '#111111',
    headerTextColor: "#fff",
    chatWindowBackgroundColor: "#141414",
    sendBarBackgroundColor: '#202020',
    position: "bottom-right",
    launcherStyle: "bubble",
    textBarGlowEnabled: true,
    textBarGlowColor: '#bae61a',
    showPoweredBy: true,
    intentLess: true
}

// Existing integrations use headerBackgroundColor as their brand color.
// An explicit primaryColor can customize actions independently of the header.
export function resolveChatBotSettings(config = {}) {
    return {
        ...defaultChatBotSettings,
        ...config,
        primaryColor: config.primaryColor || config.headerBackgroundColor || defaultChatBotSettings.primaryColor,
        textBarGlowColor: config.textBarGlowColor || config.primaryColor || config.headerBackgroundColor || defaultChatBotSettings.textBarGlowColor,
    };
}
